<template>
  <div class="appt-table">
    <h2>Session History</h2>

    <p v-if="!patient.outcomes.length">
      There is no session history yet.
    </p>

    <div v-else class="table-responsive">
      <table class="table">
        <thead>
          <tr>
            <th class="col-6">When</th>
            <th>Result</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="outcome in patient.outcomes" :key="outcome.id">
            <td class="pr-0">
              {{ new Date(outcome.when) | dateLongMonthNoYear }}
            </td>
            <td>
              <span v-if="outcome.type.includes('Canceled')">
                Canceled
              </span>
              <span v-else-if="outcome.type === 'BothNoShow'">
                Both the counselor and client did not attend
              </span>
              <span v-else-if="outcome.type === 'CounselorNoShow'">
                Counselor did not attend
              </span>
              <span v-else-if="outcome.type === 'UserNoShow'">
                Client did not attend
              </span>
              <span v-else>
                Successful
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SessionHistory',
  inject:['patient'],
}
</script>

<style lang="scss" scoped>
.appt-table {
  h2 {
    color: $green;
    font-size: 28px;
    margin-bottom: 20px;
  }
  td {
    vertical-align: middle;
    color: white;
  }
  th {
    color: white;
    border-top: 0px;
  }
}

</style>
